/* global languageCode, siteCode */

/**
 * Initialisiert die Set-Artikel-Funktionalität auf der Artikelkarte
 */
export function setArticle() {
    const form = document.querySelector('#itemcard_order_button_form_std');

    if (!form) {
        return;
    }

    // Set-Artikel-Funktionalität nur initialisieren, wenn es sich um einen Set-Artikel handelt
    if (!form.querySelector('.setItemSelection')) {
        return;
    }

    // Event-Listener für Formularänderungen hinzufügen
    form.addEventListener('change', function(event) {
        // Sichtbarkeit der Varianten-Selects aktualisieren
        updateVariantSelectVisibility(form);

        // AJAX-Call ausführen, wenn sich das Formular ändert
        sendSetItemVariantsRequest(form);
    });

    // Initial die Sichtbarkeit beim Laden setzen
    updateVariantSelectVisibility(form);
    sendSetItemVariantsRequest(form);
}

/**
 * Aktualisiert die Sichtbarkeit der Varianten-Select-Elemente
 * Das letzte select-body wird nur ausgeblendet, wenn:
 * - eine Checkbox vorhanden ist UND diese nicht gecheckt ist, ODER
 * - ein vorheriges Select vorhanden ist UND dieses keinen Wert hat
 * Wenn weder Checkbox noch vorheriges Select vorhanden ist, wird das Varianten-Select immer angezeigt
 * @param {HTMLFormElement} form - Das Formular
 */
function updateVariantSelectVisibility(form) {
    // Alle setItemGroups durchgehen
    const setGroups = form.querySelectorAll('.set[data-set-idx]');

    setGroups.forEach(setGroup => {
        const linkGroup = setGroup.getAttribute('data-set-idx');

        // Das Varianten-Select finden (pair-item-{{linkGroup}})
        const variantSelectBody = setGroup.querySelector(`#pair-item-${linkGroup}`)?.closest('.selectBody');

        if (!variantSelectBody) {
            return; // Kein Varianten-Select vorhanden
        }

        // Prüfen, ob es eine Checkbox gibt
        const checkbox = setGroup.querySelector(`input[type="checkbox"][name="set_item[${linkGroup}]"]`);

        // Prüfen, ob es ein Item-Select gibt
        const itemSelect = setGroup.querySelector(`#pair-set-item-${linkGroup}`);

        // Wenn weder Checkbox noch Item-Select vorhanden ist, immer anzeigen
        if (!checkbox && !itemSelect) {
            variantSelectBody.style.display = '';
            return;
        }

        // Wenn Checkbox vorhanden: nur anzeigen, wenn gecheckt
        if (checkbox) {
            if (checkbox.checked) {
                variantSelectBody.style.display = '';
            } else {
                variantSelectBody.style.display = 'none';
            }
            return;
        }

        // Wenn Item-Select vorhanden: nur anzeigen, wenn ein Wert ausgewählt ist
        if (itemSelect) {
            if (itemSelect.value) {
                variantSelectBody.style.display = '';
            } else {
                variantSelectBody.style.display = 'none';
            }
        }
    });
}

/**
 * Sendet das Formular per AJAX an getSetItemVariantsWithPrice
 * @param {HTMLFormElement} form - Das Formular, das gesendet werden soll
 */
function sendSetItemVariantsRequest(form) {
    // FormData aus dem Formular erstellen
    const formData = new FormData(form);

    // Alle Checkboxen im Formular finden
    const checkboxes = form.querySelectorAll('input[type="checkbox"][name^="set_item"]');

    // Für jede Checkbox: Wenn nicht gecheckt, "no_needed" als Wert setzen
    checkboxes.forEach(checkbox => {
        const checkboxName = checkbox.getAttribute('name');

        if (!checkbox.checked) {
            // Checkbox ist nicht aktiviert -> "no_needed" setzen
            formData.set(checkboxName, checkbox.dataset.defaultvalue);
        }
        // Wenn gecheckt, bleibt der ursprüngliche Wert aus der FormData erhalten
    });

    // URL mit Parametern erstellen
    const url = `/module/dcshop/GeneralAjaxData.php?function=getSetItemVariantsWithPrice&site=${siteCode}&language=${languageCode}`;

    // Fetch API für den AJAX-Call verwenden
    fetch(url, {
        method: 'POST',
        body: formData
    })
        .then(response => {
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }
            return response.json();
        })
        .then(data => {
            // Erfolgreiche Antwort verarbeiten
            if (data && data.status === 'ok') {
                handleSetItemVariantsResponse(data);
            } else {
                console.error('Fehler bei getSetItemVariantsWithPrice:', data);
            }
        })
        .catch(error => {
            console.error('AJAX-Fehler bei getSetItemVariantsWithPrice:', error);
        });
}

/**
 * Verarbeitet die Antwort von getSetItemVariantsWithPrice
 * @param {Object} response - Die Antwort vom Server
 */
function handleSetItemVariantsResponse(response) {
    // Hier kann die Antwort verarbeitet werden
    // z.B. Preise aktualisieren, Varianten anzeigen, etc.
    if(response.htmlToDom) {
        for(const element of response.htmlToDom) {
            const selector = element.domTargetSelector;
            const html = element.html;
            const orderbox = document.querySelector('.orderbox');
            if(orderbox) {
                const target = orderbox.querySelector(selector);
                if(target) {
                    target.innerHTML = html;
                }
            }

        }
    }

    if(response.customData && typeof response.customData.inventoryInfoForDom !== 'undefined') {
        for(const inventory of response.customData.inventoryInfoForDom) {
            const selector = inventory.domTargetSelector;
            const viewModel = inventory.viewModel;

            if(viewModel && Object.keys(viewModel).length > 0) {
                const code = viewModel.availability_code;
                const shipping_info = viewModel.shipping_info;

                const availabilityElement = document.getElementById(selector);
                if(availabilityElement) {
                    availabilityElement.innerHTML = `<div class="inventory ${code}">${shipping_info}</div>`;
                }
            }
        }
    }

    // Button und Mengeneingabe aktivieren/deaktivieren basierend auf enableBasketButton
    if(response.customData && typeof response.customData.enableBasketButton !== 'undefined') {
        const enableButton = response.customData.enableBasketButton;
        const isRequestItem = response.customData.isRequestItem ?? false;
        const form = document.querySelector('#itemcard_order_button_form_std');

        if(form) {
            // Alle Buttons im Formular finden
            const orderButtons = form.querySelectorAll('.orderButton');
            const quantityInputs = form.querySelectorAll('.js-quantity-value');
            const spinnerButtons = form.querySelectorAll('.quantity__spinnerItem');
            const orderButtonWrappers = form.querySelectorAll('.orderButtonWrapper');

            if(enableButton) {
                // Button aktivieren
                orderButtons.forEach(button => {
                    button.disabled = false;
                    button.classList.remove('disabled');
                    if (!isRequestItem) {
                        button.classList.add('js-addToBasketItemcard');
                    }
                    const activeText = button.getAttribute('data-active-text');
                    if (activeText && button.querySelector('span')) {
                        button.querySelector('span').textContent = activeText;
                    }
                });

                // Mengeneingabe aktivieren
                quantityInputs.forEach(input => {
                    input.disabled = false;
                });

                // Spinner-Buttons aktivieren
                spinnerButtons.forEach(spinner => {
                    spinner.removeAttribute('disabled');
                });

                // Wrapper-Klassen aktualisieren
                orderButtonWrappers.forEach(wrapper => {
                    wrapper.classList.add('is-active');
                    wrapper.classList.remove('inactive');
                });

                // Quantity-Container aktivieren
                const quantityContainers = form.querySelectorAll('.quantity');
                quantityContainers.forEach(container => {
                    container.classList.add('is-active');
                    container.classList.remove('quantity--inactive');
                });
            } else {
                // Button deaktivieren
                orderButtons.forEach(button => {
                    button.disabled = true;
                    button.classList.add('disabled');
                    button.classList.remove('js-addToBasketItemcard');
                    const inactiveText = button.getAttribute('data-inactive-text');
                    if (inactiveText && button.querySelector('span')) {
                        button.querySelector('span').textContent = inactiveText;
                    }
                });

                // Mengeneingabe deaktivieren
                quantityInputs.forEach(input => {
                    input.disabled = true;
                });

                // Spinner-Buttons deaktivieren
                spinnerButtons.forEach(spinner => {
                    spinner.setAttribute('disabled', 'disabled');
                });

                // Wrapper-Klassen aktualisieren
                orderButtonWrappers.forEach(wrapper => {
                    wrapper.classList.remove('is-active');
                    wrapper.classList.add('inactive');
                });

                // Quantity-Container deaktivieren
                const quantityContainers = form.querySelectorAll('.quantity');
                quantityContainers.forEach(container => {
                    container.classList.remove('is-active');
                    container.classList.add('quantity--inactive');
                });
            }
        }
    }
}